import { render } from "./afis_crim_check.html?vue&type=template&id=5772efd0&external"
import script from "./afis_crim_check.js?vue&type=script&lang=js&external"
export * from "./afis_crim_check.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__